module.exports = __webpack_public_path__ + "img/icon_bg7.f1d4cbe6.png";